import axios from 'axios'
import store from '@/store'
import { MessageBox } from 'element-ui'
import router from '@/router'
 
const NETWORK_ERROR_MESSAGE = '网络连接出错，请刷新重试'

// 创建axios的对象
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || "/api",  // 使用环境变量
    timeout: 5000
})

const authExpiredCodes = new Set([1011, 1008, 1007, 1006, 1002])
let reloginTask = null

function clearUserSession() {
    store.commit('CLEAR_USER_INFO')
    store.dispatch('permission/clearPermissions')
}

function triggerRelogin(message = '系统登陆已过期，请重新登录') {
    clearUserSession()
    if (reloginTask) {
        return reloginTask
    }
    reloginTask = MessageBox.alert(message, '错误', {
        confirmButtonText: '确定',
        type: 'error'
    }).catch(() => {})
      .then(() => {
          router.replace('/login').catch(() => {})
      })
      .finally(() => {
          setTimeout(() => {
              reloginTask = null
          }, 300)
      })
    return reloginTask
}

function shouldSuppressErrorAlert(config) {
    return !!(config && config.suppressErrorAlert)
}
 
// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
    function (config) {
        if (config.method === 'post') {
            // 如果是 FormData 类型（文件上传），不要处理 data
            if (!(config.data instanceof FormData)) {
                config.data = {
                  ...config.data,
                  _t: Date.parse(new Date()) / 1000 // 时间戳
                }
            }
        } else if (config.method === 'get') {
            config.params = {
              random: Math.random(), // 随机数
              ...config.params
            }
        }
        config.headers.x_access_token = window.localStorage.getItem("user_token") // 请求头添加token值
        return config
    },
    function (err) {
        return Promise.reject(err)
    }
)
 
// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
    function (response) {
        const res = response
        if (authExpiredCodes.has(res.data.code)) {
            triggerRelogin('系统登陆已过期，请重新登录')
            return Promise.reject(new Error('AUTH_EXPIRED'))
        } else if(res.data.code == 1009) {
            MessageBox.alert('该账号已被锁定', '错误', {
                confirmButtonText: '确定',
                type: 'error'
            }).then(() => {
                store.dispatch('logout').then(() => {
                    router.replace('/login').catch(() => {})
                })
            })
            return Promise.reject('error')
        } else if (res.status != 200) {
            if (!shouldSuppressErrorAlert(res.config)) {
                MessageBox.alert(NETWORK_ERROR_MESSAGE, '错误', {
                    confirmButtonText: '确定',
                    type: 'error'
                })
            }
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    function (err) {
        if (err && err.response && err.response.status === 401) {
            triggerRelogin('系统登陆已过期，请重新登录')
            return Promise.reject(new Error('AUTH_EXPIRED'))
        }
        if (!shouldSuppressErrorAlert(err && err.config)) {
            MessageBox.alert(NETWORK_ERROR_MESSAGE, '错误', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
        return Promise.reject(err)
    }
)
 
// 封装get和post请求
export function get(url, params, options = {}) {
    return instance.get(url, {
        ...options,
        params
    })
}
 
export function post(url, data, options = {}) {
    return instance.post(url, data, options)
}
 
export default instance;
